export default "__VITE_ASSET__db59f88c__"